/*
 * Copyright (c) 2023-2024. Haodong JU
 */

import hillo from 'hillo'
import { collection, doc, getDoc, getDocs, query, setDoc } from 'firebase/firestore'
import { StorageLocation } from '@/model/dataLayer/api/takeaway/fire-base'
import dayjs from 'dayjs'
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage'
import { updateRestaurantInfo } from '@/model/dataLayer/service/otherService'
import i18n from '@/i18n'
import { FireBaseStore } from '@/model/firebase/google-fire-base'
import { getBaseAndUrlForDeviceId, getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import { getCurrentStoreId } from '@/model/dataLayer/api/SaaS/user'
import GlobalSettings from '@/model/global/GlobalSettings'

const websiteUrl = 'websiteUrls'
const requiredVersion = '1.7.249'
const acsBasePath = 'https://cloud-minus.aaden.io/'
const collectionRef = collection(FireBaseStore, websiteUrl)

// hillo.initial('http://IK0001.ngrok.aaden.io')

export async function checkNgrokPass (deviceId) {
  const res = await hillo.get(`http://ik${('' + deviceId).padStart(4, '0')}.ngrok.aaden.io/`)

  return res
}

export async function checkVersionPass () {
  const { url } = await getBaseAndUrlForDeviceId(await getCurrentStoreId())
  if (url.includes('ngrok')) {
    const res = await hillo.get('https://aaden.online/jsonProxy.php?', {
      url: url + '/package.json',
      chaos: new Date().getTime()
    })
    console.log(res)
    const {
      name,
      version
    } = res
    if (!name || !version) {
      throw new Error('No Internet')
    }
    return name === 'aves' && checkVersion(version, requiredVersion)
  } else {
    return true
  }
}

function checkVersion (version, target) {
  const [main, sub, patch] = version.split('.').map(c => parseInt(c))

  const [mainT, subT, patchT] = target.split('.').map(c => parseInt(c))

  return main === mainT && (sub > subT || (sub === subT && patch >= patchT))
}

export function delayPromise (duration) {
  return function (...args) {
    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        resolve(...args)
      }, duration)
    })
  }
}

export async function setRecords (subdomainName, dataTerminalId, bannerImagePath = '',
  pickDiscountStr = '', hideDelivery = false,
  shopHomepageUrl = '', selfPickUp = false, onlyOrderToday = false, useDefaultTime = true) {
  const currentDeviceId = await getCurrentDeviceId()
  await setDoc(doc(collectionRef, currentDeviceId.toString()), {
    deviceId: currentDeviceId,
    subdomainName,
    dataTerminalId,
    bannerImagePath,
    lastModify: dayjs().toISOString(),
    pickDiscountStr,
    hideDelivery,
    selfPickUp,
    shopHomepageUrl,
    onlyOrderToday,
    useDefaultTime
  })
}

export async function setImageUrl (bannerImagePath = '') {
  const deviceId = GlobalSettings.DeviceId.toString()
  const res = (await getDoc(doc(collectionRef, deviceId.toString()))).data()
  await setDoc(doc(collectionRef, deviceId.toString()), Object.assign(res, {
    deviceId,
    bannerImagePath,
    lastModify: dayjs().toISOString()
  }))
}

export async function syncData () {
  setTimeout(() => {
    try {
      hillo.post('CloudStuff/ReportAllTerminalData.php', {}, { slient: true })
    } catch (e) {

    }
  }, 50)
}

export async function showRecords () {
  const res = query(collectionRef)
  return await resultOf(res)
}

function deviceIdToPassword (deviceId) {
  return `IK${('' + deviceId).padStart(4, '0')}`
}

export async function getDataterminalByDeviceId (deviceId) {
  const password = deviceIdToPassword(deviceId)
  let organisationId = null

  const org = await hillo.jsonPost(acsBasePath + 'organisations/register', {
    name: password,
    password
  })
  organisationId = org.id

  return await getDataterminalByOrgId(organisationId)
}

async function getDataterminalByOrgId (organisationId) {
  return (await hillo.get(acsBasePath + 'dataTerminals/')).find(d => d.organisation.id === organisationId)
}

async function createAuthCode (organisationId, name) {
  return (await hillo.jsonPost(acsBasePath + 'authCodes/create', {
    authCodeTypeId: 2,
    organisationId,
    name: name + ' Auth Code'
  })).code
}

async function createDataTerminal (code, id, password, ngrokBasePath) {
  const enableRequest = await hillo.post(`${ngrokBasePath}/PHP/CloudStuff/CreateMaster.php?code=${code}`, {
    id,
    password
  })
  if (enableRequest !== 'done') {
    throw new Error(enableRequest)
  }
}

export async function fullActiveTakeawayWeb () {
  const deviceId = await getCurrentDeviceId()
  const password = deviceIdToPassword(deviceId)
  const { url: ngrokBasePath } = await getBaseAndUrlForDeviceId(deviceId)
  let organisationId = null
  let errorInfo = ''

  try {
    const org = await hillo.jsonPost(acsBasePath + 'organisations/register', {
      name: password,
      password
    })
    organisationId = org.id
    if (org.isNew) {
      // 组织创建成功
      const code = await createAuthCode(organisationId, password)
      // 创建了新的验证码
      await createDataTerminal(code, organisationId, password, ngrokBasePath)
      // 本地服务器也已经创建成功
    } else {
      // ⚡该密码已经创建过一次组织。所以我认为要不然就是失败了，要不然就是你在重新创建已有的组织。所以我们后面要稍微小心一点了!
      // 正在检查是否有对应的组织
      const existDataTerminal = await getDataterminalByOrgId(organisationId)

      if (existDataTerminal) {
        // 找到了对应的DataTerminal，所以说上次已经创建完了，那我们就直接下一步了
        // DataTerminalId是' + existDataTerminal.id

        return [existDataTerminal.id, '']
      } else {
        // 没找到啊，问题不大，那我们就直接下一步了'
        const code = await createAuthCode(organisationId, password)
        // 创建了新的验证码。

        await createDataTerminal(code, organisationId, password, ngrokBasePath)
        // 本地服务器也已经创建成功。
      }
    }
  } catch (e) {
    console.log(e)
    errorInfo = i18n.t('TakeawayErrorInfo') +
      '<br>*（' + i18n.t('SenseiSuGeMobile') + ': 017675874266)<br>' + i18n.t('ContentOfError')
  }

  const res = await getDataterminalByOrgId(organisationId)

  return [res.id, errorInfo]
}

export function getNgrokUrl (deviceId) {
  return `http://ik${('' + deviceId).padStart(4, '0')}.ngrok.aaden.io`
}

export async function resultOf (query, logLabel = '') {
  const res = (await getDocs(query)).docs
    .map(contentOf)
  if (logLabel) {
    console.log(res, logLabel)
  }
  return res
}

export function contentOf (doc) {
  return doc.data()
}

export async function uploadImage (file, type = 'banner') {
  const deviceId = await getCurrentStoreId()
  const name = deviceId + '-' + type + '.' + (file.name.split('.').pop())
  await uploadBytes(ref(StorageLocation, name), file, { name })
  return await getDownloadURL(ref(StorageLocation, name))
}

export async function syncTakeawaySettingToCloud (newRestaurantInfo) {
  if (newRestaurantInfo) {
    await updateRestaurantInfo(newRestaurantInfo)
  }
}

export async function getActivityPostList () {
  return (await hillo.get('ActivityPost.php?op=getActivityPostList')).content
}

export async function createActivityPostList (content, file) {
  return (await hillo.postWithUploadFile('ActivityPost.php?op=createActivityPost', {
    content,
    file
  })).content
}

export async function updateActivityPostList (id, content, file) {
  return (await hillo.postWithUploadFile('ActivityPost.php?op=updateActivityPost', {
    id,
    content,
    file
  })).content
}

export async function deleteActivityPostList (id) {
  return (await hillo.post('ActivityPost.php?op=deleteActivityPost', {
    id
  })).content
}
